import axios from "axios";
import * as types from "../mutation-types";
import logger from "~/utilities/logger";

// state
export const state = {
  profession_list: [],
  index_data: null,
  profession_select: null,
  the_id: null,
};

// getters
export const getters = {
  profession_list: (state) => state.profession_list,
  check_list: (state) => state.profession_list !== null,
  profession_select: (state) => state.profession_select,
  the_id: (state) => state.the_id,
};

//utils
export const getProfessionIndexById = (state, profId) =>
  state.profession_list.findIndex(
    (prof) => prof.prof_id.toString() === profId.toString()
  );
export const getProfessionByProfId = (state, profId) =>
  state.profession_list.find(
    (prof) => prof.prof_id.toString() === profId.toString()
  );
export const getProfessionByShortName = (state, profShort) =>
  state.profession_list.find(
    (prof) => prof.prof_short_name.toString() === profShort.toString()
  );

// mutations
export const mutations = {
  [types.ADD_PROFESSION](state, profession)
  {
    return state.profession_list.push(profession);
  },
  [types.ADD_PROFESSION_FAILURE](state, error) {},

  [types.FETCH_PROFESSIONS](state, { profession_list })
  {
    return (state.profession_list = profession_list);
  },

  [types.FETCH_PROFESSIONS_FAILURE](state)
  {
    logger.error("FETCH_PROFESSIONS_FAILURE");
  },

  [types.FETCH_PROFESSION](state, { profession_select })
  {
    return (state.profession_select = profession_select);
  },

  [types.FETCH_PROFESSION_FAILURE](state, { error })
  {
    logger.error("FETCH_PROFESSION_FAILURE", error);
  },

  [types.SELECT_PROFESSION](state, { prof_id })
  {
    let theSelect = getProfessionByProfId(state, prof_id);
    logger.log("store.SELECT_PROFESSION", theSelect);
    return (state.profession_select = theSelect);
  },

  [types.DESELECT_PROFESSION](state)
  {
    return (state.profession_select = null);
  },

  [types.DELETE_PROFESSION](state, { prof_id })
  {
    logger.log("store.DELETE_PROFESSION", state, prof_id);
    const index = getProfessionIndexById(state, prof_id);
    if (index === -1)
    {
      return console.warn(`Unable to delete profession (id ${prof_id})`);
    }
    return state.profession_list.splice(index, 1);
  },

  [types.UPDATE_PROFESSION](state, { payload })
  {
    // state.profession_select = payload.cou_name;
  },

  [types.SET_PROFESSION_ID](state, { id })
  {
    return (state.the_id = id);
  },

  [types.SEARCH_PROFESSIONS](state, { profession_list })
  {
    return (state.profession_list = profession_list);
  },

  [types.SEARCH_PROFESSIONS_FAILURE](state, error)
  {
    logger.error("SEARCH_PROFESSIONS_FAILURE", error);
  },
};

// actions
export const actions = {
  async addProfession({ commit }, profession)
  {
    try
    {
      logger.log("store.addProfession", "/api/professions", profession);
      const { data } = await axios.post("/api/professions", profession);
      if (data.status && data.status === "success")
      {
        logger.log("store.addProfession rsp", data);
        return commit(types.ADD_PROFESSION, data.data);
      } else
      {
        return commit(types.ADD_PROFESSION_FAILURE, data);
      }
    } catch (e)
    {
      logger.log("ADD_PROFESSION_FAILURE", e);
      return commit(types.ADD_PROFESSION_FAILURE, e);
    }
  },

  async getProfessions({ commit }, options)
  {
    try
    {
      let paginate = options && options.paginate ? options.paginate : 10000;
      let extraOptions =
        options && options.extra_options ? options.extra_options : "";
      let format = options && options.format ? options.format : "minimal";

      const { data } = await axios.get(
        `/api/professions?status=active&paginate=${paginate}&format=${format}${extraOptions}`
      ); //todo
      logger.log("store.getProfessions", data);
      return commit(types.FETCH_PROFESSIONS, {
        profession_list: data.data.data,
      });
    } catch (e)
    {
      logger.error("store.getProfessions error", e);
      return commit(types.FETCH_PROFESSIONS_FAILURE);
    }
  },

  async getProfession({ commit, dispatch }, payload)
  {
    if (!payload.prof_id) return;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    let format = payload && payload.format ? payload.format : "minimal";
    try
    {
      const { data } = await axios.get(`/api/professions/${payload.prof_id}`);
      logger.log("store.getProfession rsp", data);
      return commit(types.FETCH_PROFESSION, { profession_select: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_PROFESSION_FAILURE, { error: e });
    }
  },

  async deleteProfession({ commit, dispatch }, payload)
  {
    if (!payload.prof_id) return;
    let paginate = payload && payload.paginate ? payload.paginate : 10000;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    try
    {
      const { data } = await axios.delete(
        `/api/professions/${payload.prof_id}${extraOptions}`
      );
      logger.log("store.deleteProfession rsp", data);
      return commit(types.DELETE_PROFESSION, { prof_id: payload.prof_id });
    } catch (e)
    {
      logger.error("DELETE_PROFESSION_FAILURE", e);
      // return commit(types.DELETE_PROFESSION_FAILURE, { error: e });
    }
  },

  async updateProfession({ commit, dispatch }, payload)
  {
    try
    {
      const { data } = await axios.put(
        `/api/professions/${payload.prof_short}`,
        payload
      );
      logger.log("store.updateProfession", data);
      return commit(types.UPDATE_PROFESSION, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_PROFESSION_FAILURE, { error: e });
    }
  },

  setProfessionID({ commit, dispatch }, id)
  {
    return commit(types.SET_PROFESSION_ID, { id: id });
  },

  async searchProfessions({ commit }, query)
  {
    try
    {
      const { data } = await axios.get(`/api/professions?search=${query}`);
      logger.log("store.searchProfessions", data);
      return commit(types.SEARCH_PROFESSIONS, {
        profession_list: data.data.data,
      });
    } catch (e)
    {
      logger.error("store.searchProfessions error", e);
      return commit(types.SEARCH_PROFESSIONS_FAILURE, e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
